<ng-container *ngIf="data == 'color-picker'">
    <h1 mat-dialog-title>Pick a color</h1>
    <div mat-dialog-content style="margin: 0; max-height: unset; padding: 0; overflow: visible;">
        <input style="width: 100%; height: 150px; border: none; background: transparent;" type="color"
            [(ngModel)]="pickedColor" name="colorpicker" id="colorpicker">
        <div class="button-flex d-flex w-100 justify-content-between" [ngClass]="{'flex-row-reverse' : actionsToRight}">
            <div mat-dialog-actions>
                <button mat-button color="primary" style="color: var(--bs-primary) !important;" [ngClass]="{'order-1 ml-2': confirmToRight, 'order-0': !confirmToRight}"
                    (click)="onChooseColor()" cdkFocusInitial>
                    Submit
                </button>
            </div>
            <div mat-dialog-actions align="end">
                <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="data == 'clear-confirmation'">
    <h1 mat-dialog-title>Alert</h1>
    <div mat-dialog-content>
        <p>Are you sure you want to clear the drawings?</p>
    </div>
    <div mat-dialog-actions
        [ngClass]="{'justify-content-end' : actionsToRight, 'justify-content-start' : !actionsToRight}">
        <button [ngClass]="{'order-1 ml-2': confirmToRight, 'order-0': !confirmToRight}" mat-button color="primary"
            (click)="onClearAnnotation()" style="color: var(--bs-primary) !important;">Yes</button>
        <button mat-button color="warn" (click)="onCancel()">No</button>
    </div>
</ng-container>